/* @flow */

import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore.js';

type TypeProps = {|
  formData: Object,
  actionDrawerStore: TypeActionDrawerStore,
  parentForm: Object,
  model: Object,
  localState: Object,
  fields: Object,
|} & TranslatorProps;

@translate()
@inject('actionDrawerStore')
@observer
export default class AddNewCostCenterSuccess extends React.Component<*> {
  componentDidMount() {
    const { actionDrawerStore, parentForm, model, localState, fields }: TypeProps = this.props;

    if (fields.costCentre) {
      const field: Object = parentForm.$(`${fields.costCentre}`);
      const fieldExtra: Object = field.extra;

      field.set('value', actionDrawerStore.response.name);
      field.set('extra', { ...fieldExtra, selectID: actionDrawerStore.response.id });

      if (localState && typeof localState.selectedValueCC !== 'undefined') {
        localState.selectedValueCC === ''
          ? (localState.selectedValueCC = actionDrawerStore.response.id)
          : (localState.selectedValueCC = `${localState.selectedValueCC},${
              actionDrawerStore.response.id
            }`);

        field.set('value', localState.selectedValueCC);
      }

      model.loadData();
    }

    actionDrawerStore.closeActionDrawer();
  }

  render(): React.Element<*> {
    return 'success';
  }
}
